import React, { useState, useRef, useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import Breadcrumb from '../../components/Breadcrumb'
import LoadingSection from '../../components/loadingSection'
import { fetchProductPackage } from '../products/productActions'
import { displayNotification } from '../../actions/notificationsActions'

const Iframe = ({ productPackage }) => {
  if (!productPackage) {
    return null
  }

  const src = `${process.env.REACT_APP_BLINKER_API_URL}/public/packages/${productPackage.customerToken}/sign`

  const style = {
    width: '100%',

    // 123px = 76px top bar + 42px breadcrumb + 5px possible scrollbar
    height: 'calc(100vh - 123px)',
  }

  return <iframe src={src} style={style} />
}

const DocumentSubmissionForm = () => {
  const useQuery = () => new URLSearchParams(useLocation().search)
  const query = useQuery()
  const packageId = query.get('packageId')

  const dispatch = useDispatch()
  const history = useHistory()

  const [state, setState] = useState({
    productPackage: null,
    levels: [
      { label: 'Index', path: '/' },
      { label: 'People', path: '/users' },
    ],
  })

  // track reference to user for profile redirect
  const userRef = useRef()

  const loadProductPackage = async () => {
    const productPackage = await dispatch(fetchProductPackage(packageId))

    // if the package hasn't been finalized (a product agreement doesn't exist)
    // then assume the VIN needs to be validated and redirect to the refi app
    // (it should load the Vehicle Details with a "VIN required" error)
    if (!productPackage.productAgreement) {
      history.replace(`/refiApp?packageId=${packageId}`)
      dispatch(
        displayNotification(
          'Please enter the VIN to validate the selected plan'
        )
      )
      return
    }

    const { user } = productPackage
    const { firstName, lastName, id } = user

    userRef.current = user

    setState({
      productPackage,
      levels: state.levels.concat([
        { label: `${firstName} ${lastName}`, path: `/users/${id}` },
        { label: 'Agreement' },
      ]),
    })
  }

  useEffect(() => {
    loadProductPackage()

    // listen for message from iframe page
    const onMessage = (event) => {
      switch (event.data.type) {
        case 'AGREEMENT_SUCCESS':
          // Return to user profile
          // TODO: something else?
          history.replace(`/users/${userRef.current.id}`)
          dispatch(displayNotification('Agreement signed'))
          break
        case 'AGREEMENT_CANCELED':
          // Return to user profile
          history.replace(`/users/${userRef.current.id}`)
      }
    }

    window.addEventListener('message', onMessage)

    return () => {
      window.removeEventListener('message', onMessage)
    }
  }, [])

  const levels = [].concat(state.levels)
  if (!state.productPackage) {
    levels.push({ label: 'Loading...' })
  }

  return (
    <>
      <Breadcrumb levels={levels} />
      <LoadingSection isLoading={!state.productPackage}>
        <Iframe productPackage={state.productPackage} />
      </LoadingSection>
    </>
  )
}

export default DocumentSubmissionForm
